export const searchNav = ({ frameId = null } = {}) => ({
  focusFirstItem() {
    this._navItems()[0]?.focus()
  },

  focusNextItem() {
    const items = this._navItems()
    items[items.indexOf(document.activeElement) + 1]?.focus()
  },

  focusPrevItem() {
    const items = this._navItems()
    const index = items.indexOf(document.activeElement)
    if (index <= 0) this.$root.querySelector('input[type="search"]')?.focus()
    else items[index - 1].focus()
  },

  _navItems() {
    const list = this.$refs.navList
                 || (frameId && document.getElementById(frameId))
    if (!list) return []
    return Array.from(list.querySelectorAll('[data-nav-action]'))
  },
})
